<script>
    export let letter = "C";
    export let text = "";
    export let background = "#ff0000";
    export let link = "https://google.com";
</script>

<main>
    <a href={link} target="_blank">
        <div class="icon" style="--background-color: {background}">
            <div class="letter">{letter}</div>
        </div>
        <div class="text">
            {text}
        </div>
    </a>
</main>

<style lang="scss">
    a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        width: 80px;
        color: white;

        text-decoration: none;

        &:hover {
            .icon {
                border: 4px solid white;
            }
        }
    }
    .icon {
        display: flex;

        background: var(--background-color);

        align-items: center;
        justify-content: center;

        width: 60px;
        height: 60px;

        font-size: 52px;

        font-weight: bold;

        box-sizing: border-box;
    }
    .text {
        color: white;
        font-size: 12px;

        margin-top: 6px;
    }
</style>
